module.exports = __webpack_public_path__ + "img/symbol_12.c9b19945.png";